export default __webpack_public_path__ + "static/media/facebook-logo.585ea61f.svg";